import { getStaticProps } from '@/modules/custom404/custom404.props'

export { getStaticProps }

import Custom404 from '@/modules/custom404/Custom404'
import displayPage from '@/layout/PageLayout';

export default displayPage(Custom404);
